import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from "vue";
import { INTAKE_STAGE } from "@/models/intakeStatus";
import { openStepOf, stepLabel, stepRoute } from "@/models/intakeSteps";
export default /*@__PURE__*/ _defineComponent({
    __name: 'IntakeStepNotice',
    props: {
        step: {},
        status: {},
        orderId: {},
        orderInfo: {},
        reviewOrderInfo: {}
    },
    setup(__props) {
        const props = __props;
        const ARCHIVED = new Set([INTAKE_STAGE.ARCHIVED, "DISCONTINUE_PROCESSING"]);
        const target = computed(() => {
            if (!props.status || ARCHIVED.has(props.status))
                return null;
            const open = openStepOf(props.status);
            if (open && open !== props.step) {
                const label = stepLabel(open);
                return { text: `This order is at ${label}.`, action: `Open ${label}`, to: stepRoute(open, props.orderId) };
            }
            if (open && props.reviewOrderInfo && !props.orderInfo) {
                return {
                    text: "This review decides a prior authorization.",
                    action: "Open prior authorization",
                    to: { name: "check-my-coverage", params: { id: props.reviewOrderInfo } },
                };
            }
            if (!open && props.orderInfo) {
                return {
                    text: "This order has a prior authorization.",
                    action: "Open prior authorization",
                    to: {
                        name: "check-my-coverage",
                        params: { id: props.orderInfo },
                        ...(props.status === INTAKE_STAGE.DENIAL_FOLLOWUP ? { query: { section: "appeal" } } : {}),
                    },
                };
            }
            return null;
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_alert = _resolveComponent("v-alert");
            return (target.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "info",
                    variant: "tonal",
                    density: "compact",
                    class: "mb-4 intake-step-notice",
                    "data-testid": "intake-step-notice"
                }, {
                    append: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            to: target.value.to,
                            variant: "text",
                            size: "small",
                            color: "primary",
                            "data-testid": "intake-step-notice-link"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(target.value.action), 1)
                            ]),
                            _: 1
                        }, 8, ["to"])
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(target.value.text) + " ", 1)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
